module.exports = __webpack_public_path__ + "static/img/chuangxin1.af6219b2.png";